import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../../common/components/dashboard_layout.component';
import { SystemVendorInvoiceTable } from './SystemVendorInvoiceTable';
import styles from '../VendorInvoiceManagement/vendor_invoice_management.module.css';

export const SystemVendorInvoiceManagement = () => {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState('all-invoices');

  const permissionNames = useMemo(() => {
    try {
      const stored = localStorage.getItem('permissions');
      if (!stored) {
        return [];
      }
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed.map((p) => p.name) : [];
    } catch (error) {
      console.error('Failed to parse permissions:', error);
      return [];
    }
  }, []);

  useEffect(() => {
    if (!permissionNames.includes('System Invoice Management Vendor')) {
      navigate('/rov', { replace: true });
    }
  }, [permissionNames, navigate]);

  return (
    <DashboardLayout padding={true}>
      <div className={styles['vendor-invoice-container']}>
        <div className={styles['tabs-row']}>
          <div className={styles['tabs-container']}>
            <button
              className={`${styles['tab']} ${selectedTab === 'all-invoices' ? styles['tab-active'] : ''}`}
              onClick={() => setSelectedTab('all-invoices')}
            >
              Active Invoices
            </button>
            <button
              className={`${styles['tab']} ${selectedTab === 'reverted-invoices' ? styles['tab-active'] : ''}`}
              onClick={() => setSelectedTab('reverted-invoices')}
            >
              Closed Invoices
            </button>
          </div>
          <button
            className={styles['new-invoice-button']}
            onClick={() => navigate('/systemInvoiceManagementVendor/newInvoice')}
          >
            New Invoice
          </button>
        </div>

        <SystemVendorInvoiceTable selectedTab={selectedTab} />
      </div>
    </DashboardLayout>
  );
};
